import { useEffect, useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = ({ children }) => {
  const location = useLocation();
  // useLayoutEffect(() => {
  //   window.scrollTo({ top: 0, behavior: "smooth" });
  //   // document.documentElement.scrollTo(0, 0);
  // }, [location.pathname]);
  useEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 100); // delay ensures it runs after paint
  }, [location.pathname]);
  return children;
};

export default ScrollToTop;
